import { jsx, jsxs } from "react/jsx-runtime";
import FormatColorReset from "@mui/icons-material/FormatColorReset";
import { Button, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { Fragment } from "react";
import { Accordion } from "./Accordion/Accordion.js";
import { AccordionDetails } from "./Accordion/AccordionDetails.js";
import { AccordionSummary } from "./Accordion/AccordionSummary.js";
import { Color } from "./Color.js";
import { ColorHeaderPreview } from "./ColorHeaderPreview.js";
function ColorPreview(props) {
  const {
    id,
    color,
    changedColor,
    expanded,
    onExpand,
    onReset,
    onResetColor,
    onChangeColor,
    onSetAsPrimaryColor,
    renderExtraControl
  } = props;
  const handleOnExpand = (_event, newExpanded) => {
    onExpand?.(id, newExpanded);
  };
  const handleChangeColor = (key, color2) => {
    onChangeColor?.(id, key, color2);
  };
  const handleResetColor = (key) => {
    onResetColor?.(id, key);
  };
  const handleOnReset = (evt) => {
    evt.stopPropagation();
    evt.preventDefault();
    onReset?.(id);
  };
  const colorsKeys = Object.keys(color).filter((key) => !key.includes("Channel"));
  const colorsValuesPreview = [];
  const colorsValuesModified = [];
  for (const [key, val] of Object.entries(color).slice(0, 4)) {
    colorsValuesPreview.push(val);
    const colorModified = !!changedColor?.[key];
    colorsValuesModified.push(colorModified);
  }
  const anyColorModified = Object.keys(changedColor ?? {}).length > 0;
  return /* @__PURE__ */ jsxs(Accordion, { expanded, onChange: handleOnExpand, children: [
    /* @__PURE__ */ jsxs(AccordionSummary, { "aria-controls": `panel${id}-content`, id: `panel${id}-header`, children: [
      /* @__PURE__ */ jsx(Typography, { variant: "subtitle1", children: id }),
      /* @__PURE__ */ jsxs(Stack, { direction: "row", gap: 1, sx: { alignItems: "center" }, children: [
        /* @__PURE__ */ jsx(Tooltip, { placement: "bottom", title: "Reset", children: /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(IconButton, { component: "div", disabled: !anyColorModified, onClick: handleOnReset, children: /* @__PURE__ */ jsx(FormatColorReset, {}) }) }) }),
        /* @__PURE__ */ jsx(ColorHeaderPreview, { colors: colorsValuesPreview, modified: colorsValuesModified })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(AccordionDetails, { children: [
      /* @__PURE__ */ jsx(Stack, { gap: 1.5, children: colorsKeys.map((colorId) => {
        const uid = colorId;
        const colorString = color[colorId];
        const key = `${id}.${colorId}.${colorString}`;
        const isColorModified = !!(changedColor ? changedColor[colorId] : void 0);
        if (typeof colorString === "number") {
          return void 0;
        }
        const extraControl = renderExtraControl?.(uid);
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Color,
            {
              color: colorString,
              id: uid,
              modified: isColorModified,
              onChange: handleChangeColor,
              onReset: handleResetColor
            }
          ),
          Boolean(extraControl) && extraControl
        ] }, key);
      }) }),
      onSetAsPrimaryColor && /* @__PURE__ */ jsx(Button, { onClick: onSetAsPrimaryColor, sx: { justifyContent: "flex-start", pl: 2, textTransform: "none" }, children: "Set as primary" })
    ] })
  ] });
}
export {
  ColorPreview
};
//# sourceMappingURL=ColorPreview.js.map
